import React from "react";
import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { DAFTAR_URL, LOGIN_URL } from "../../config/links";

const HERO_BG =
    "https://static.prod-images.emergentagent.com/jobs/0c325fa0-c7de-49b3-9474-6afba2a9cd35/images/bad9b2309a50f8720dc847e8e23e7f217115ef9fce770626f1fe620a98cf0def.png";

export default function Hero() {
    return (
        <section
            id="beranda"
            data-testid="hero-section"
            className="relative min-h-[92vh] flex items-center justify-center overflow-hidden"
        >
            <div className="absolute inset-0">
                <img
                    src={HERO_BG}
                    alt="PUSATCUAN platform hiburan digital terbaik dengan nuansa mewah emas dan hitam"
                    className="w-full h-full object-cover opacity-60"
                    loading="eager"
                    fetchpriority="high"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/40 via-[#050505]/60 to-[#050505]" />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.12),transparent_60%)]" />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center py-32">
                <div
                    data-testid="hero-eyebrow"
                    className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/5 backdrop-blur-sm mb-8 fade-up"
                >
                    <Sparkles size={14} className="text-[#D4AF37]" />
                    <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                        Situs Hiburan No 1 Indonesia
                    </span>
                </div>

                <h1
                    data-testid="hero-title"
                    className="fade-up text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white tracking-tighter leading-[1.05] max-w-5xl mx-auto"
                    style={{ animationDelay: "0.1s" }}
                >
                    <span className="text-gold-gradient">PUSATCUAN</span>: Platform
                    Hiburan Digital{" "}
                    <span className="italic font-normal text-white/90">Terbaik</span>{" "}
                    & Link Resmi Terpercaya
                </h1>

                <p
                    data-testid="hero-description"
                    className="fade-up mt-8 text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed"
                    style={{ animationDelay: "0.2s" }}
                >
                    Akses <strong className="text-white">pusatcuan slot</strong> dan
                    seluruh game online terbaru melalui{" "}
                    <strong className="text-[#D4AF37]">link resmi terpercaya</strong>.
                    Situs hiburan online terpercaya dengan sistem keamanan tingkat
                    tinggi, transaksi kilat, dan layanan 24 jam nonstop.
                </p>

                <div
                    className="fade-up mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
                    style={{ animationDelay: "0.3s" }}
                >
                    <a
                        data-testid="hero-cta-daftar"
                        href={DAFTAR_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#F3E5AB] text-black font-semibold px-8 py-4 rounded-full transition-all hover:scale-105 animate-gold-pulse"
                    >
                        Daftar Sekarang
                        <ArrowRight
                            size={18}
                            className="transition-transform group-hover:translate-x-1"
                        />
                    </a>
                    <a
                        data-testid="hero-cta-login"
                        href={LOGIN_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-white/90 border border-white/15 hover:border-[#D4AF37]/60 hover:text-[#D4AF37] px-8 py-4 rounded-full transition-all"
                    >
                        Login Member
                    </a>
                </div>

                <div
                    className="fade-up mt-14 flex flex-wrap items-center justify-center gap-6 text-xs text-white/50"
                    style={{ animationDelay: "0.5s" }}
                >
                    <span className="inline-flex items-center gap-2">
                        <ShieldCheck size={14} className="text-[#D4AF37]" />
                        Enkripsi SSL 256-bit
                    </span>
                    <span className="hidden sm:inline text-white/20">|</span>
                    <span>Lisensi Resmi Internasional</span>
                    <span className="hidden sm:inline text-white/20">|</span>
                    <span>Akses Game Online Terbaru 24/7</span>
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#050505] to-transparent pointer-events-none" />
        </section>
    );
}
